const shopImageHoverDelay = 200;
const shopImageHoverTimers = new WeakMap();

const cancelShopImageHover = (card) => {
  window.clearTimeout(shopImageHoverTimers.get(card));
  shopImageHoverTimers.delete(card);
};

const setActiveShopImage = (card, nextIndex) => {
  const images = Array.from(card.querySelectorAll('[data-colet-shop-image]'));

  if (images.length < 2) {
    return;
  }

  const index = (nextIndex + images.length) % images.length;

  images.forEach((image, imageIndex) => {
    image.classList.toggle('is-active', imageIndex === index);
  });

  card.dataset.coletShopIndex = String(index);
};

const canPreviewShopImagesOnHover = () =>
  window.matchMedia('(hover: hover) and (pointer: fine)').matches;

document.addEventListener('pointerover', (event) => {
  const media = event.target.closest('.colet-shop-card__media');

  if (!media || media.contains(event.relatedTarget) || event.pointerType === 'touch' || !canPreviewShopImagesOnHover()) {
    return;
  }

  const card = media.closest('[data-colet-shop-card]');

  if (!card || card.querySelectorAll('[data-colet-shop-image]').length < 2) {
    return;
  }

  cancelShopImageHover(card);
  shopImageHoverTimers.set(card, window.setTimeout(() => {
    shopImageHoverTimers.delete(card);

    if (media.isConnected && media.matches(':hover') && canPreviewShopImagesOnHover()) {
      setActiveShopImage(card, 1);
    }
  }, shopImageHoverDelay));
});

document.addEventListener('pointerout', (event) => {
  const media = event.target.closest('.colet-shop-card__media');

  if (!media || media.contains(event.relatedTarget) || event.pointerType === 'touch') {
    return;
  }

  const card = media.closest('[data-colet-shop-card]');

  if (card) {
    cancelShopImageHover(card);
    setActiveShopImage(card, 0);
  }
});

document.addEventListener('click', (event) => {
  const control = event.target.closest('[data-colet-shop-prev], [data-colet-shop-next]');

  if (!control) {
    return;
  }

  const card = control.closest('[data-colet-shop-card]');

  if (!card) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  cancelShopImageHover(card);

  const currentIndex = Number(card.dataset.coletShopIndex || 0);
  const direction = control.matches('[data-colet-shop-prev]') ? -1 : 1;

  setActiveShopImage(card, currentIndex + direction);
});
